import { notifyViewFinishedLoading } from '@wix/business-manager-api';
import React from 'react';
import { ModuleRegistry } from 'react-module-container';
import { HomePage } from '../../components/HomePage';
import { COMPONENT_NAME } from '../../config';
import { fedopsLogger } from '../../services/fedopsLogger';

import styles from './App.scss';

interface IAppProps {
  mediaToken: string;
}

export class App extends React.Component<IAppProps> {
  componentDidMount() {
    fedopsLogger.appLoaded();
    notifyViewFinishedLoading(COMPONENT_NAME);
  }

  render() {
    const { mediaToken } = this.props;

    return (
      <div className={styles.root} data-testid="home-page-component">
        <HomePage
          mediaToken={mediaToken}
          AscendUpgradeButtonComponent={ModuleRegistry.component(
            'ascend-upgrade-button-lazy-component',
          )}
          AscendBadgeComponent={ModuleRegistry.component(
            'ascend-badge-lazy-component',
          )}
        />
      </div>
    );
  }
}
